<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img :src="image" height="100%">
      <v-layout class="fill-height" tag="v-list" column>
        <v-list-tile avatar>
          <v-list-tile-avatar color="white">
            <v-img :src="logo" height="46" contain/>
          </v-list-tile-avatar>
          <v-list-tile-title class="title">漂流 - 管理端</v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <!-- <v-list-tile v-if="responsive">
          <v-text-field class="purple-input search-input" label="Search..." color="purple"/>
        </v-list-tile>-->
        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          class="v-list-item"
          @click="$title = link.text"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-text="link.text"/>
        </v-list-tile>
        <v-list-tile
          active-class="primary"
          class="v-list-item v-list__tile--buy"
          @click="onClickLogout"
        >
          <v-list-tile-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-light">退出</v-list-tile-title>
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import global from '@/global'
import { mapMutations, mapState } from 'vuex'

export default {
  data: () => ({
    logo: './img/logo.png',
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    links() {
      return [
        {
          to: '/dashboard',
          icon: 'mdi-view-dashboard',
          text: this.$t('Core.Drawer.dashboard')
        },
        {
          to: '/user-list',
          icon: 'mdi-account',
          text: this.$t('Core.Drawer.userList')
        },
        {
          to: '/book-list',
          icon: 'mdi-book',
          text: this.$t('Core.Drawer.bookList')
        },
        {
          to: '/link-list',
          icon: 'mdi-link-variant',
          text: this.$t('Core.Drawer.linkList')
        },
        {
          to: '/comment-list',
          icon: 'mdi-comment',
          text: this.$t('Core.Drawer.commentList')
        },
        {
          to: '/keyword-list',
          icon: 'mdi-block-helper',
          text: this.$t('Core.Drawer.keywordList')
        }
        // {
        //   to: '/sayhello',
        //   icon: 'mdi-cloud-braces',
        //   text: this.$t('Core.Drawer.sayHello')
        // },
        // {
        //   to: '/user-profile',
        //   icon: 'mdi-account',
        //   text: this.$t('Core.Drawer.userProfile')
        // },
        // {
        //   to: '/table-list',
        //   icon: 'mdi-clipboard-outline',
        //   text: this.$t('Core.Drawer.tableList')
        // },
        // {
        //   to: '/typography',
        //   icon: 'mdi-format-font',
        //   text: this.$t('Core.Drawer.typography')
        // },
        // {
        //   to: '/icons',
        //   icon: 'mdi-chart-bubble',
        //   text: this.$t('Core.Drawer.icons')
        // },
        // {
        //   to: '/maps',
        //   icon: 'mdi-map-marker',
        //   text: this.$t('Core.Drawer.maps')
        // },
        // {
        //   to: '/notifications',
        //   icon: 'mdi-bell',
        //   text: this.$t('Core.Drawer.notifications')
        // }
      ]
    },
    inputValue: {
      get() {
        return this.$store.state.app.drawer
      },
      set(val) {
        this.setDrawer(val)
      }
    },
    items() {
      return this.$t('Layout.View.items')
    }
  },
  mounted() {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },
    onClickLogout() {
      global.clearStorage()
      window.location.replace('/')
    }
  }
}
</script>

<style lang="stylus">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
